const actions = {
  setup() {},
  async getData({ dispatch }, reportKey) {
    return dispatch('tools/setView', reportKey, { root: true })
  },
}

export default actions
